import { PriorityLevelPageResponse, PriorityLevelRequest as PriorityLevelRequestDto, PriorityLevelResponse } from "lib-klab-sdks";
import { PriorityLevel, PriorityLevelPage, PriorityLevelRequest } from "../../../domain/models/requirement/priority-level.model";

export function mapPriorityLevel(source: PriorityLevelResponse): PriorityLevel {
  return {
    id: source.priorityLevelId,
    code: source.code,
    name: source.name,
    requiresJustification: source.requiresJustification,
    requiresEvidence: source.requiresEvidence,
    sortOrder: source.sortOrder,
    colorHex: source.colorHex,
    statusId: source.statusId,
    createdAt: source.createdAt,
    updatedAt: source.updatedAt,
  };
}

export function mapPriorityLevelRequest(request: PriorityLevelRequest): PriorityLevelRequestDto {
  return {
    code: request.code,
    name: request.name,
    requiresJustification: request.requiresJustification,
    requiresEvidence: request.requiresEvidence,
    sortOrder: request.sortOrder,
    colorHex: request.colorHex,
    statusId: request.statusId,
  };
}

export function mapPriorityLevelPage(source: PriorityLevelPageResponse): PriorityLevelPage {
  return {
    items: source.items.map(mapPriorityLevel),
    limit: source.limit,
    offset: source.offset,
    hasNext: source.hasNext,
    total: source.total,
  };
}
